import { useQuery } from 'react-query'
import { fetchUser } from 'api/clients/userClient'

export default (options = {}) => useQuery('user', fetchUser, options)
